import { render, staticRenderFns } from "./add_department_model.vue?vue&type=template&id=4810d340&scoped=true&"
import script from "./add_department_model.vue?vue&type=script&lang=js&"
export * from "./add_department_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4810d340",
  null
  
)

export default component.exports